
export class InformacaoReceitaFederal {
  id_empresa: number;
  atividade_principal: string;
  data_situacao: string;
  complemento: string;
  tipo: string;
  qsa: string;
  situacao: string;
  bairro: string;
  logradouro: string;
  numero: string;
  cep: string;
  municipio: string;
  fantasia: string;
  porte: string;
  abertura: string;
  natureza_juridica: string;
  uf: string;
  cnpj: string;
  ultima_atualizacao: string;
  email: string;
  telefone: string;
  atividades_secundarias: string;
  capital_social: string;
  constructor() {

  }
}
